import { render } from "./One7.vue?vue&type=template&id=4ed4ccaa&scoped=true&lang=pug"
import script from "./One7.vue?vue&type=script&lang=js"
export * from "./One7.vue?vue&type=script&lang=js"

import "./One7.vue?vue&type=style&index=0&id=4ed4ccaa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed4ccaa"]])

export default __exports__